import { getRole } from '../../features/realtime/realtime.selectors';
import { RealtimeRole } from '../../features/realtime/realtime.types';
import { useAppSelector } from '../useReduxToolkit';
import {
  useProviderViewCallParticipants,
  UseProviderViewCallParticipantsReturnType,
  ProviderViewCallParticipant,
} from '../useProviderViewCallParticipants';
import {
  usePatientViewCallParticipants,
  UsePatientViewCallParticipantsReturnType,
  PatientViewCallParticipant,
} from '../usePatientViewCallParticipants';

export type CallParticipant =
  | ProviderViewCallParticipant
  | PatientViewCallParticipant;

export type UseCallParticipantsReturnType =
  | UseProviderViewCallParticipantsReturnType
  | UsePatientViewCallParticipantsReturnType;

export const useCallParticipants = (): UseCallParticipantsReturnType => {
  const role = useAppSelector(getRole);

  const providerViewCallParticipants = useProviderViewCallParticipants();
  const patientViewCallParticipants = usePatientViewCallParticipants();

  return role === RealtimeRole.Provider
    ? providerViewCallParticipants
    : patientViewCallParticipants;
};
